"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrudWebPipelineProxy = void 0;
const webPipelineProxy_1 = require("./webPipelineProxy");
const axiosRequestBuilder_1 = require("../axiosRequestBuilder");
const guard_1 = require("../utils/guard");
/**
 * A basic CRUD web pipeline proxy.
 */
class CrudWebPipelineProxy extends webPipelineProxy_1.WebPipelineProxy {
    /**
     * Initializes a new instance of the @see CrudWebPipelineProxy class.
     * @param pipeline Pipeline to use if any.
     * @param itemCache Item cache to use if any.
     * @param tokenCache Token cache to use if any.
     * @param baseUrl Base URL to use. Must be set.
     * @param logger Logger to use if any.
     * @param maintenance Maintenance to use if any.
     */
    constructor(pipeline = null, itemCache = null, tokenCache = null, baseUrl = null, logger = null, maintenance = null) {
        guard_1.Guard.throwIfNullOrEmpty(baseUrl, 'baseUrl');
        super(pipeline, itemCache, tokenCache, baseUrl, logger, maintenance);
    }
    /**
     * Adds a new item.
     * @param item Item to add.
     * @returns Web response.
     */
    add(item) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = axiosRequestBuilder_1.AxiosRequestBuilder.new()
                .post()
                .withBody(item)
                .build();
            return this.execute(request);
        });
    }
    /**
     * Deletes an item.
     * @param id Id of item to delete.
     * @returns Web response.
     */
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            guard_1.Guard.throwIfNullOrEmpty(id, 'id');
            const request = axiosRequestBuilder_1.AxiosRequestBuilder.new()
                .delete(`/${id}`)
                .build();
            return this.execute(request);
        });
    }
    /**
     * Gets an item by its Id.
     * @param id Id of item to get.
     * @param cacheKey Optional cache key for item.
     * @returns Web response.
     */
    get(id, cacheKey) {
        return __awaiter(this, void 0, void 0, function* () {
            guard_1.Guard.throwIfNullOrEmpty(id, 'id');
            const request = axiosRequestBuilder_1.AxiosRequestBuilder.new()
                .get(`/${id}`)
                .build();
            return this.execute(request, cacheKey);
        });
    }
    /**
     * Gets all items.
     * @param cacheKey Optional cache key for items.
     * @returns Web response.
     */
    list(cacheKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = axiosRequestBuilder_1.AxiosRequestBuilder.new()
                .get()
                .build();
            return this.execute(request, cacheKey);
        });
    }
    /**
     * Updates an item.
     * @param id Id of item to update.
     * @param item Item to update.
     * @returns Web response.
     */
    update(id, item) {
        return __awaiter(this, void 0, void 0, function* () {
            guard_1.Guard.throwIfNullOrEmpty(id, 'id');
            const request = axiosRequestBuilder_1.AxiosRequestBuilder.new()
                .put(`/${id}`)
                .withBody(item)
                .build();
            return this.execute(request);
        });
    }
}
exports.CrudWebPipelineProxy = CrudWebPipelineProxy;
//# sourceMappingURL=crudWebPipelineProxy.js.map